import React from 'react';
import "../App.css";
import BackToHomePage from "./BackToHomePage";
import Home from './Home';
import Snow from './Snow';

class BestWork extends Home{
    constructor(props){
        super(props);
    }

    render(){
        return(
            <div className={this.state.scale}>

            <Snow></Snow>

            <div id="title" className=
                "text-white text-center text-3xl md:text-5xl mt-5">
                <h1 className="p-7 font-black">Relevant projects</h1>
            </div>

            <div
            className="mx-5 md:mx-48 text-white text-1xl md:text-4xl p-5 text-mono my-10">
                <article className="text-center leading-normal font-black leading-loose">
                  <a href="https://github.com/milanm98/Facebook-Message-Sender/blob/main/HD.py">Facebook automated message sender</a><br></br>
                  <a href="https://github.com/milanm98/ChessClub-website">Chess Club Website (mobile design)</a><br></br>
                  <a href="https://github.com/milanm98/login-form-with-stairs-animation">Login form with stairs animation</a><br></br>
                  <a href="https://github.com/milanm98/SIMM">Smart investments - SIMM</a><br></br>
                  <a href="https://github.com/milanm98/Optimal-stake-calculator">Modified Kelly criterion</a><br></br>
                  <a href="https://github.com/milanm98/Home-data-exploit">Data exploit script</a><br></br>
                </article>

            </div>

            <BackToHomePage></BackToHomePage>

            </div>
        )
    }

}


export default BestWork;